import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OtherReceivablesInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OtherReceivablesInternalControls({ onBack, setActiveSection, controlsListSection }: OtherReceivablesInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Receivables"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}
